import BaseModule from './BaseModule.js';

class CustomerAccessAlert extends BaseModule {
  async paginate({ page, per_page, term, severity, context, customer_id }) {
    return await this.get(`/back-office/customer-access-alerts`, {
      params: {
        page,
        per_page,
        term,
        severity,
        context,
        customer_id,
      },
    });
  }
}

export default CustomerAccessAlert;
